var map = {
	"./address-book.jpg": 8312,
	"./animtaion-cubes.jpg": 2183,
	"./appify/1.png": 5380,
	"./appify/2.png": 968,
	"./appify/3.png": 4068,
	"./appify/4.png": 4896,
	"./appify/5.png": 4812,
	"./bookshelf/1.jpg": 3932,
	"./bookshelf/2.jpg": 1864,
	"./bookshelf/3.jpg": 1640,
	"./bookshelf/4.jpg": 412,
	"./bookshelf/5.jpg": 7528,
	"./calculator.jpg": 4864,
	"./finance_app/1.jpg": 7944,
	"./finance_app/2.jpg": 8628,
	"./finance_app/3.jpg": 5184,
	"./finance_app/4.jpg": 3224,
	"./finance_app/5.jpg": 3048,
	"./finance_app/6.jpg": 3820,
	"./golden.jpg": 392,
	"./goseechat/1.jpg": 904,
	"./goseechat/2.jpg": 2092,
	"./goseechat/3.jpg": 1876,
	"./hounter-landing.jpg": 9404,
	"./jewelty.jpg": 1972,
	"./kyiv-realty.jpg": 6756,
	"./lavbet.jpg": 7388,
	"./login-form.jpg": 5648,
	"./market-house.jpg": 3264,
	"./mododomus.jpg": 1476,
	"./neural-network.jpg": 3352,
	"./nexchance/1.jpg": 8580,
	"./nexchance/10.jpg": 3360,
	"./nexchance/11.jpg": 8918,
	"./nexchance/12.jpg": 4548,
	"./nexchance/13.jpg": 4280,
	"./nexchance/2.jpg": 4312,
	"./nexchance/3.jpg": 348,
	"./nexchance/4.jpg": 9316,
	"./nexchance/5.jpg": 5437,
	"./nexchance/6.jpg": 7972,
	"./nexchance/7.jpg": 6004,
	"./nexchance/8.jpg": 9432,
	"./nexchance/9.jpg": 3692,
	"./portal/1.jpg": 9020,
	"./portal/2.jpg": 6400,
	"./portal/3.jpg": 7772,
	"./portal/4.jpg": 3976,
	"./prelit/1.jpg": 332,
	"./prelit/2.jpg": 5452,
	"./prelit/3.jpg": 6392,
	"./prelit/4.jpg": 8048,
	"./prelit/5.jpg": 1572,
	"./premier-palace.jpg": 9628,
	"./printing-landing.jpg": 6600,
	"./profile_person/1.jpg": 9220,
	"./profile_person/2.jpg": 8148,
	"./proxy/1.jpg": 7165,
	"./proxy/2.jpg": 3088,
	"./proxy/3.jpg": 1204,
	"./proxy/4.jpg": 3012,
	"./react-to-do-list.jpg": 1988,
	"./react-web-shop.jpg": 5300,
	"./resume.jpg": 6432,
	"./spektrum.jpg": 7448,
	"./stomadeus.jpg": 4200,
	"./to-do-list.jpg": 248,
	"./usermanagement.jpg": 6128,
	"./weather-forecast.jpg": 5908
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4928;